/* eslint-disable no-undef */
import './navigation-drawer'
import './navigation-dropdown'
import './cookies'
import './dropdown-input-phone'

const chevronDownIcon = `<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M3 4.5L6 7.5L9 4.5" stroke="#94A3B8" stroke-linecap="round" stroke-linejoin="round"/>
</svg>`

document.querySelectorAll('.link-item .arrow-down').forEach((el) => {
  el.innerHTML += chevronDownIcon
})

const hamburgerIcon = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M3 12H21M3 6H21M3 18H21" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>`

document.querySelector('.btn-hamburger').innerHTML += hamburgerIcon

const preHeadingIcon = `<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect width="32" height="32" rx="16" fill="white" fill-opacity="0.2"/>
<path d="M21.8263 13.725V19.825C21.8263 21.7667 20.2513 23.3333 18.318 23.3333H12.1763C10.243 23.3333 8.66797 21.7583 8.66797 19.825V13.725C8.66797 11.7833 10.243 10.2167 12.1763 10.2167H18.318C20.2513 10.2167 21.8263 11.7917 21.8263 13.725Z" fill="white" fill-opacity="0.5" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M11.582 8.33333V6.875" stroke="white" stroke-opacity="0.5" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M14.918 8.33333V6.875" stroke="white" stroke-opacity="0.5" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M18.25 8.33333V6.875" stroke="white" stroke-opacity="0.5" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M25.3326 15.9667C25.3326 17.9 23.7576 19.475 21.8242 19.475V12.4584C23.7576 12.4584 25.3326 14.025 25.3326 15.9667Z" stroke="white" stroke-opacity="0.5" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M8.66797 15H21.593" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>`

document.querySelector('.contents__contactUs--preHeadingIcon').innerHTML +=
  preHeadingIcon

const arrowUpRightIcon = `<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M4.66602 11.3333L11.3327 4.66663M11.3327 4.66663H4.66602M11.3327 4.66663V11.3333" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
</svg>`

document.querySelectorAll('.visit-us--link').forEach((el) => {
  el.innerHTML += arrowUpRightIcon
})

// const liberiaFlagIcon = `<svg width="22" height="16" viewBox="0 0 22 16" fill="none" xmlns="http://www.w3.org/2000/svg">
// <g clip-path="url(#clip0_2242_11676)">
// <rect width="22" height="16" rx="3" fill="#1A47B8"/>
// <path fill-rule="evenodd" clip-rule="evenodd" d="M2.34035 0H0V2.66667L19.6469 16L22 16V13.3333L2.34035 0Z" fill="white"/>
// <path d="M0.780579 0L22 14.4378V16H21.2377L0 1.54726V0H0.780579Z" fill="#F93939"/>
// <path fill-rule="evenodd" clip-rule="evenodd" d="M19.9048 0H22V2.66667C22 2.66667 8.39122 11.5499 2.09524 16H0V13.3333L19.9048 0Z" fill="white"/>
// <path d="M22 0H21.2895L0 14.4502V16H0.780579L22 1.55895V0Z" fill="#F93939"/>
// <path fill-rule="evenodd" clip-rule="evenodd" d="M8.00075 0H14.0176V4.93527H22V11.0615H14.0176V16H8.00075V11.0615H0V4.93527H8.00075V0Z" fill="white"/>
// <path fill-rule="evenodd" clip-rule="evenodd" d="M9.26316 0H12.7368V6.15385H22V9.84615H12.7368V16H9.26316V9.84615H0V6.15385H9.26316V0Z" fill="#F93939"/>
// </g>
// <defs>
// <clipPath id="clip0_2242_11676">
// <rect width="22" height="16" rx="3" fill="white"/>
// </clipPath>
// </defs>
// </svg>`

// document.querySelector('.contactUs--inputPhoneArrowFlagsIcon').innerHTML += liberiaFlagIcon

const arrowIcon = `<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M4 6L8 10L12 6" stroke="#CBD5E1" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>`

document.querySelector('.contactUs--inputPhoneArrowIcon').innerHTML += arrowIcon

document
  .querySelector('.contactUsForm')
  .addEventListener('submit', function (e) {
    e.preventDefault()

    Toastify({
      text: 'The contact us submission form has been successfully sent!',
      duration: 3000,
      gravity: 'top', // `top` or `bottom`
      position: 'center', // `left`, `center` or `right`
      stopOnFocus: true, // Prevents dismissing of toast on hover
      style: {
        background: '#05a6f0',
        fontFamily: '"Montserrat", sans-serif',
        fontSize: '14px',
      },
      // onClick: function () {} // Callback after click
    }).showToast()
    setTimeout(() => {
      document.querySelector('.contactUsForm').reset()
      document.querySelector(
        '.contactUs--inputPhoneContainer .contactUs--contentEditable',
      ).textContent = ''
    }, 1500)
  })

document
  .querySelector('.contactUs--inputPhoneContainer .contactUs--contentEditable')
  .addEventListener('keypress', (e) => {
    const regex = /\d/
    const phoneCode = document.querySelector(
      '.contactUs--inputPhoneContainer .contactUs--inputPhoneArrow p',
    ).textContent
    const symbol = String.fromCharCode(e.keyCode)
    if (!regex.test(symbol)) {
      e.preventDefault()
    }
    setTimeout(() => {
      document.querySelector('.contactUs--inputPhoneContainer input').value =
        phoneCode + e.target.textContent
    }, 1000)
  })

document
  .querySelector('.contactUs--inputPhoneContainer .contactUs--contentEditable')
  .addEventListener('keydown', function (event) {
    const phoneCode = document.querySelector(
      '.contactUs--inputPhoneContainer .contactUs--inputPhoneArrow p',
    ).textContent

    if (event.key === 'Backspace') {
      setTimeout(() => {
        if (event.target.textContent === '') {
          document.querySelector(
            '.contactUs--inputPhoneContainer input',
          ).value = ''
        } else {
          document.querySelector(
            '.contactUs--inputPhoneContainer input',
          ).value = phoneCode + event.target.textContent
        }
      }, 1000)
    }
  })
